import { AccessControlPage as SharedAccessControlPage } from '@trinetra/shared';
import { useNode } from '../contexts/NodeContext';

/**
 * Cloud Access Control — assign the selected node's camera groups + individual
 * cameras to the cloud users granted access to that node. Node-scoped: follows
 * the globally-selected node (same as Cameras/Groups/Models). Thin wrapper over
 * the shared page; data flows through useApi().accessControl (cloudAccessControlApi).
 */
export default function AccessControlPage() {
  const { selectedNode } = useNode();
  return (
    <SharedAccessControlPage
      requireNode
      nodeKey={selectedNode?.nodeId ?? null}
      nodeLabel="Site"
      editPermission="users.edit"
    />
  );
}
